import { Middleware, isRejectedWithValue } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

import { HttpStatus } from '@/types/httpStatus';
import { Side } from '@/utils/enums';

import { baseApi } from '../api/baseApi';
import { ApiTags, CommonTagIds } from '../api/tags';

type NegotiationAction = {
  meta: {
    arg: {
      originalArgs: {
        id: number;
        data: {
          version: number;
        };
        companyId?: string;
        sideView?: Side;
      };
      endpointName: string;
    };
  };
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isNegotiationAction = (action: any): action is NegotiationAction => {
  return (
    !!action.meta?.arg?.originalArgs?.id &&
    typeof action.meta?.arg?.endpointName === 'string' &&
    action.meta?.arg?.endpointName.toLowerCase().includes('negotiation') &&
    action.meta?.arg?.originalArgs?.data?.version !== null &&
    action.meta?.arg?.originalArgs?.data?.version !== undefined
  );
};

export const negotiationConflictHandler: Middleware = api => next => action => {
  if (!isNegotiationAction(action)) {
    return next(action);
  }

  const {
    meta: {
      arg: {
        originalArgs: { companyId, sideView, id },
      },
    },
  } = action;

  // Handle negotiation actions which are in rejected state
  if (isRejectedWithValue(action)) {
    const payload = action.payload as FetchBaseQueryError;

    // handle only HTTP 409 (conflict)
    if (payload.status === HttpStatus.CONFLICT) {
      // Invalidate tags for the negotiation in question and the negotiation list
      api.dispatch(
        baseApi.util.invalidateTags([{ type: ApiTags.NEGOTIATIONS, id }])
      );

      if (companyId && sideView) {
        api.dispatch(
          baseApi.util.invalidateTags([
            {
              type: ApiTags.NEGOTIATIONS,
              id: `${CommonTagIds.LIST}-${companyId}-${sideView}`,
            },
          ])
        );
      }
    }
  }

  return next(action);
};
